import styled from 'styled-components';
import { IconOpenInNew } from 'cdk-radial';
import { environmentURLs } from '../common/CaptureEnvironment';
import { sendAmplitudeData } from '../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../constants/amplitudeConstants';

const docsBase = environmentURLs.REACT_APP_NAV_DOCS_URL;

const LearnMoreLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  font-family: ${({ theme }) => theme.font.family.main.value};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.25px;
  text-decoration: none;
  color: ${({ theme }) => theme.color.primary[500].value};
`;
const LearnMoreSuffixIcon = styled(IconOpenInNew)`
  width: 1rem;
  height: 1rem;
  fill: ${({ theme }) => theme.color.primary[500].value};
  opacity: 1;
`;

const LearnMore = ({ url, docPath, linkText = 'Learn More', screen }) => {
  return (
    <LearnMoreLink
      onClick={()=> sendAmplitudeData(screen.concat(' Learn More'),{})}
      target="_blank"
      href={url || `${docsBase}${docPath}`}
      rel="noopener noreferrer"
    >
      {linkText}
      <LearnMoreSuffixIcon />
    </LearnMoreLink>
  );
};
export default LearnMore;
